import fetch from '@/util/http'

export default {
  shareData(model) {
    return fetch.post('share/insert', model)
  }
}



// WEBPACK FOOTER //
// ./src/api/record.js